import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import Fab from '@material-ui/core/Fab';
import { isTablet } from 'react-device-detect';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import './PreviewModeLayer.css';
import AppContext from '../../contexts/AppContext';
import htmlParse from 'react-html-parser';
import { Typography } from '@material-ui/core';

const styles = () => ({
  fabRoot: {
    position: 'fixed',
    top: '100px',
    left: '20px',
    zIndex: -1,
  },
  fabRootTablet: {
    position: 'fixed',
    top: '100px',
    right: '20px',
    zIndex: -1,
  },
  listIcon: {
    marginTop: '10px',
  },
});

class PreviewModeLayer extends Component {
  static contextType = AppContext;

  render() {
    const {
      classes,
      currentLocation,
      onToggleArtworks,
      loadedGallery,
    } = this.props;
    const { dictionnary } = this.context;

    let rootClass = classes.fabRoot;
    if (isTablet) {
      rootClass = classes.fabRootTablet;
    }

    return (
      <>
        <div className={rootClass}>
          <div>
            {false && (
              <div id="preview-layer-text">
                {htmlParse(dictionnary.get('preview-content'))}
              </div>
            )}
            <Fab
              variant="extended"
              color="secondary"
              aria-label="add"
              className={classes.listIcon}
              onClick={() => {
                this.props.onBackButtonHandler();
              }}
            >
              <ArrowBackIcon />
              &nbsp;
              {htmlParse(dictionnary.get('preview-return'))}
            </Fab>
          </div>
        </div>

        <div id={'container-details-flex'}>
          {currentLocation && (
            <>
              <div id={'container-details'}>
                <Typography>
                  {loadedGallery && this.props.loadedGallery.meta && (
                    <>
                      {dictionnary.get('common-curated')}{' '}
                      <span>{this.props.loadedGallery.meta.creator}</span>
                      <br />
                    </>
                  )}
                  <span id="container-details-link">
                    {currentLocation.city}, {currentLocation.name}
                  </span>{' '}
                </Typography>
              </div>
              <div
                id={'container-details-artworks'}
                onClick={() => {
                  onToggleArtworks();
                }}
              >
                {dictionnary.get('common-artworks-in')}
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

export default withStyles(styles)(PreviewModeLayer);
